/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Auth_Gate_TitleInputs */

const en_common_auth_gate_title = /** @type {(inputs: Common_Auth_Gate_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in to continue`)
};

const zh_common_auth_gate_title = /** @type {(inputs: Common_Auth_Gate_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录以继续`)
};

/**
* | output |
* | --- |
* | "Sign in to continue" |
*
* @param {Common_Auth_Gate_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_auth_gate_title = /** @type {((inputs?: Common_Auth_Gate_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Auth_Gate_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_auth_gate_title(inputs)
	return zh_common_auth_gate_title(inputs)
});
export { common_auth_gate_title as "common.auth.gate.title" }